import { Modal } from "@mui/material";
import React from "react";
import { useHistory } from "react-router-dom";
import { useRecoilState } from "recoil";
import { missingRequisitions } from "../../recoil/atoms";
import { MissingRequisitionResponse } from "../../recoil/types";
import { useDeviceHook } from "../../utils/hooks/useDeviceHook";
import { REQUISITION_URL } from "../../utils/urlConstants";
import { Button } from "../shared/Button/Button";
import {
  MissingInfoModalWrapper,
  MissingInfoModalGrid,
  MissingInfoModalGridRow,
  MissingInfoModalGridWrapper,
  MissingInfoModalMessage,
  MissingInfoModalTitle,
  ModalButtons,
  MissingInfoStatusIndicator,
  PatientReleaseModalText,
  MissingInfoModalGridRowWrapper,
} from "./Grid.styles";

const getMissingInfoTabs = (missingInfoReq: MissingRequisitionResponse) => {
  const tabs: string[] = [];
  if (missingInfoReq.is_missing_treatment_notes) {
    tabs.push("Missing Treatment Notes");
  }
  if (missingInfoReq.is_missing_billing_info) {
    tabs.push("Missing Billing Info");
  }
  if (missingInfoReq.is_missing_due_date) {
    tabs.push("Missing Due Date");
  }
  return tabs;
};

const getMissingInfoRoute = (missingInfoReq: MissingRequisitionResponse) => {
  if (missingInfoReq.is_missing_treatment_notes) {
    return "#req-treatment-notes";
  }
  if (missingInfoReq.is_missing_billing_info) {
    return "#req-billing-information";
  }
  if (missingInfoReq.is_missing_due_date) {
    return "#req-general-information";
  }
  return "";
};

export const MissingInfoModal: React.FC<{
  missingInfoModalOpen: boolean;
  setMissingInfoModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ missingInfoModalOpen, setMissingInfoModalOpen }) => {
  const { deviceType } = useDeviceHook();
  const history = useHistory();
  const [allMissingRequisitions] = useRecoilState(missingRequisitions);

  return (
    <Modal
      open={missingInfoModalOpen}
      onClose={setMissingInfoModalOpen}
      style={{
        alignItems: "center",
        justifyContent: "center",
        display: "flex",
      }}
    >
      <MissingInfoModalWrapper deviceType={deviceType}>
        <MissingInfoModalTitle deviceType={deviceType}>
          ACTION NEEDED
        </MissingInfoModalTitle>
        <MissingInfoModalMessage>
          Please provide required information to complete the order:
        </MissingInfoModalMessage>
        <MissingInfoModalGridWrapper>
          <MissingInfoModalGrid>
            <MissingInfoModalGridRowWrapper header>
              <PatientReleaseModalText heading>
                REQUISITION NAME
              </PatientReleaseModalText>
              <PatientReleaseModalText heading>TYPE</PatientReleaseModalText>
            </MissingInfoModalGridRowWrapper>
            {(Array.isArray(allMissingRequisitions)
              ? allMissingRequisitions
              : []
            )
              .filter((req) => Boolean(getMissingInfoTabs(req).length))
              .map((req) => (
                <MissingInfoModalGridRowWrapper
                  key={req.sfid}
                  onClick={() =>
                    history.push(
                      `${REQUISITION_URL}/${req.sfid}/${getMissingInfoRoute(
                        req,
                      )}`,
                    )
                  }
                >
                  <MissingInfoModalGridRow>
                    {`${req.full_name}`}
                  </MissingInfoModalGridRow>
                  <div>
                    {getMissingInfoTabs(req).map((tab) => (
                      <MissingInfoStatusIndicator key={tab}>
                        {tab}
                      </MissingInfoStatusIndicator>
                    ))}
                  </div>
                </MissingInfoModalGridRowWrapper>
              ))}
          </MissingInfoModalGrid>
        </MissingInfoModalGridWrapper>
        <ModalButtons>
          <Button
            label="CLOSE"
            onClick={() => setMissingInfoModalOpen(false)}
            size="small"
          />
        </ModalButtons>
      </MissingInfoModalWrapper>
    </Modal>
  );
};
